/* ============================================================
   ww-forms.js - behaviour for the price match and quote modals (snippets/product-*-form.liquid)
     · live competitor grand total vs our total (price match)
     · vehicle field prefilled from the Convermax selection
     · attachments: files upload to our endpoint (data-ww-upload-url on the modal), the links go in
       the email through the hidden contact[attachments] field. Endpoint contract:
         POST multipart, field "file"  →  200 JSON { "url": "https://..." }   (anything else = failure)
   ============================================================ */
(function () {
  'use strict';
  if (window.__wwForms) return;
  window.__wwForms = true;

  var fr = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;
  var MAX_MB = 10;
  var T = fr
    ? { uploading: 'Envoi…', done: 'Ajouté', failed: 'Échec, réessayez', tooBig: 'Trop volumineux (max ' + MAX_MB + ' Mo)', type: 'Images ou PDF seulement', wait: 'Un instant, envoi des fichiers…' }
    : { uploading: 'Uploading…', done: 'Attached', failed: 'Failed, try again', tooBig: 'Too large (max ' + MAX_MB + ' MB)', type: 'Images or PDF only', wait: 'One moment, uploading files…' };

  function money(n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function num(el) { var v = parseFloat(el && el.value); return isFinite(v) ? v : 0; }

  /* ── price match totals ── */
  function initTotals(modal) {
    var box = modal.querySelector('.ww-fm__product');
    var ourUnit = box ? parseFloat(box.getAttribute('data-our-unit')) / 100 : NaN;   /* cents → dollars */
    var qty = modal.querySelector('[data-pm-qty]'), unit = modal.querySelector('[data-pm-unit]');
    var ship = modal.querySelector('[data-pm-ship]'), tax = modal.querySelector('[data-pm-tax]');
    var totals = modal.querySelector('[data-pm-totals]');
    if (!qty || !unit || !totals) return;
    var date = modal.querySelector('[data-pm-date]');
    if (date && !date.value) {
      var d = new Date(); date.value = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
      date.max = date.value;
    }
    function update() {
      var q = Math.max(1, Math.round(num(qty)));
      var theirs = num(unit) * q + num(ship) + num(tax);
      var ours = isFinite(ourUnit) ? ourUnit * q : NaN;
      var has = num(unit) > 0;
      totals.hidden = !has;
      if (!has) return;
      modal.querySelector('[data-pm-theirs]').textContent = money(theirs);
      modal.querySelector('[data-pm-ours]').textContent = isFinite(ours) ? money(ours) : ' - ';
      var diffEl = modal.querySelector('[data-pm-diff]'), wrap = diffEl.closest('.ww-fm__totals-diff');
      if (isFinite(ours)) {
        var diff = ours - theirs;
        diffEl.textContent = (diff >= 0 ? '−' : '+') + money(Math.abs(diff));
        wrap.classList.toggle('is-higher', diff < 0);           /* competitor is more expensive */
      }
      var hf = modal.querySelector('[data-pm-theirs-field]'), of = modal.querySelector('[data-pm-ours-field]');
      if (hf) hf.value = money(theirs) + ' CAD (' + q + ' x ' + money(num(unit)) + ' + shipping ' + money(num(ship)) + ' + taxes/fees ' + money(num(tax)) + ')';
      if (of) of.value = isFinite(ours) ? money(ours) + ' CAD (' + q + ' x ' + money(ourUnit) + ', before shipping and tax)' : '';
    }
    [qty, unit, ship, tax].forEach(function (el) { el.addEventListener('input', update); });
    update();
  }

  /* ── vehicle prefill ── */
  function initVehicle(modal) {
    var el = modal.querySelector('[data-ww-vehicle]');
    if (!el || el.value) return;
    var tries = 0, t = setInterval(function () {
      try {
        var v = window.Convermax && window.Convermax.getVehicle && window.Convermax.getVehicle();
        if (v && v.Year && v.Make && v.Model) {
          el.value = [v.Year, v.Make, v.Model, v.Submodel].filter(Boolean).join(' ');
          clearInterval(t);
        }
      } catch (e) {}
      if (++tries > 20) clearInterval(t);
    }, 250);
  }

  /* ── attachments ── */
  function initAttach(modal) {
    var url = (modal.getAttribute('data-ww-upload-url') || '').trim();
    var wrap = modal.querySelector('[data-ww-attach]');
    if (!wrap) return;
    if (!url || !window.FormData || !window.fetch) return;         /* no endpoint: box stays hidden */
    wrap.hidden = false;
    var input = wrap.querySelector('[data-ww-attach-input]'), drop = wrap.querySelector('.ww-fm__drop');
    var list = wrap.querySelector('[data-ww-attach-list]'), field = wrap.querySelector('[data-ww-attach-field]');
    var form = modal.querySelector('form');
    var items = [];                                                   /* { name, url, li } */
    var pending = 0;

    function sync() { field.value = items.filter(function (i) { return i.url; }).map(function (i) { return i.url; }).join('\n'); }

    function add(file) {
      var li = document.createElement('li');
      var img = document.createElement('img'); img.alt = '';
      var name = document.createElement('span'); name.className = 'name'; name.textContent = file.name;
      var state = document.createElement('span'); state.className = 'state';
      var rm = document.createElement('button'); rm.type = 'button'; rm.textContent = '×'; rm.setAttribute('aria-label', 'Remove');
      li.appendChild(img); li.appendChild(name); li.appendChild(state); li.appendChild(rm);
      list.appendChild(li);
      var item = { name: file.name, url: '', li: li };
      items.push(item);
      rm.addEventListener('click', function () { items.splice(items.indexOf(item), 1); li.remove(); sync(); });

      if (/^image\//.test(file.type)) { img.src = URL.createObjectURL(file); }
      else { img.style.display = 'none'; }

      if (file.size > MAX_MB * 1024 * 1024) { li.classList.add('is-error'); state.textContent = T.tooBig; return; }
      if (!/^image\//.test(file.type) && file.type !== 'application/pdf') { li.classList.add('is-error'); state.textContent = T.type; return; }

      state.textContent = T.uploading;
      pending++;
      var fd = new FormData(); fd.append('file', file, file.name);
      fetch(url, { method: 'POST', body: fd, credentials: 'omit' })
        .then(function (r) {
          return r.text().then(function (txt) {
            var j = null; try { j = JSON.parse(txt); } catch (e) {}
            if (!r.ok || !j || !j.url) {
              /* show the server's own reason (or the HTTP status) so a failure can be diagnosed from the page */
              var why = (j && j.error) ? j.error : ('HTTP ' + r.status);
              console.warn('[Wheelwiz] upload failed:', r.status, txt.slice(0, 300));
              throw new Error(why);
            }
            return j;
          });
        })
        .then(function (j) { item.url = String(j.url); li.classList.add('is-done'); state.textContent = T.done; sync(); })
        .catch(function (err) {
          li.classList.add('is-error');
          state.textContent = T.failed + (err && err.message ? ' (' + err.message + ')' : '');
          if (!err || !err.message) console.warn('[Wheelwiz] upload request never reached the server (blocked by CORS, mixed content, or network)');
        })
        .then(function () { pending--; });
    }

    input.addEventListener('change', function () { [].slice.call(input.files || []).forEach(add); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { [].slice.call(e.dataTransfer && e.dataTransfer.files || []).forEach(add); });
    drop.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); } });

    /* don't submit while a file is still on its way up */
    if (form) form.addEventListener('submit', function (e) {
      if (!pending) return;
      e.preventDefault();
      var btn = form.querySelector('.ww-fm__submit');
      if (btn) { btn.disabled = true; btn.textContent = T.wait; }
      var t = setInterval(function () { if (!pending) { clearInterval(t); form.submit(); } }, 200);
    });
  }

  function init() {
    [].slice.call(document.querySelectorAll('.ww-fm')).forEach(function (modal) {
      if (modal.__ww) return; modal.__ww = true;
      initTotals(modal); initVehicle(modal); initAttach(modal);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
